export enum StepName {
  REGISTRATION_AUTHENTICATE = 'REGISTRATION_AUTHENTICATE',
  REGISTRATION_AUTHENTICATE_OTP = 'REGISTRATION_AUTHENTICATE_OTP',
  REGISTRATION_SELECT_TRAINING = 'REGISTRATION_SELECT_TRAINING',
  REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS',
  REGISTRATION_FAILED = 'REGISTRATION_FAILED',
  REGISTRATION_PARTIAL_SUCCESS = 'REGISTRATION_PARTIAL_SUCCESS',
  REGISTRATION_HISTORY = 'REGISTRATION_HISTORY',
  EVENTS_VIEW = 'EVENTS_VIEW',
  WHATS_NEW = 'WHATS_NEW',
  MY_PROGRESS = 'MY_PROGRESS',
  LEADERBOARD = 'LEADERBOARD',
}

export interface Step {
  state: string;
  component: any;
}
